import uuid from 'react-native-uuid'

export const getUUID = () => uuid.v4().toString()
